<div>
	<lib-card [isForm]="true" [title]="'Details'" [isInDialog]="isInDialog()">
		<ui-text-form-field
			[title]="workoutOrActivitySingular() + ' name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Recommended length'"
			[isRequired]="false"
			[valueAsSignal]="form.recommendedLength"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Notes'"
			[valueAsSignal]="form.notes"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>

		@if (showIconSelectionField()) {
		<ui-icon-selection-form-field
			class="push-top-md"
			[title]="'Icon'"
			[valueAsSignal]="form.iconType"
			[availableIconTypes]="availableIconTypes"
			[isInDialog]="isInDialog()"
		></ui-icon-selection-form-field>
		}
	</lib-card>

	@if (showInstructionFields()) {
	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Instructions'" class="push-top-md">
		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Warm up'"
			[valueAsSignal]="form.warmUp"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Cooldown'"
			[valueAsSignal]="form.cooldown"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>
	</lib-card>
	} @if (enableAvatarEditInFormComponents && isEditForm()) {
	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Avatar'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[maxFiles]="1"
			[imageCrop]="defaultSquareImageCrop"
			[isRequired]="false"
			[uploadFunction]="uploadFunction"
			[valueAsSignal]="form.avatar"
			[enableImageGallery]="true"
			(valueChange)="handleUploadImage($event)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>
	}

	<ui-form-save-button
		class="push-top-md"
		[title]="isEditForm() ? 'Save' : 'Create'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
		[isInDialog]="isInDialog()"
	></ui-form-save-button>
</div>
